import React from 'react';
import './Resources.css';

const Resources = () => {
  const griefBooks = [
    { title: "All the Beauty in the World", author: "Patrick Bringley" },
    { title: "Ambiguous Loss: Learning to Live with Unresolved Grief", author: "Pauline Boss" },
    { title: "Bittersweet", author: "Susan Cain" },
    { title: "Codependent No More", author: "Melody Beattie" },
    { title: "Everywhere, Still: A Book about Loss, Grief, and the Way Love Continues", author: "M.H. Clark", note: "Picture Book (For Children/Teens)" },
    { title: "A Grief Observed", author: "C. S. Lewis", note: "Christian Perspective" },
    { title: "The Grief Recovery Handbook for Pet Loss", author: "Russell Friedman" },
    { title: "The Grieving Brain: The Surprising Science of How We Learn from Love and Loss", author: "Mary-Frances O'Connor" },
    { title: "The Grieving Body: How the Stress of Loss Can Be an Opportunity for Healing", author: "Mary-Frances O'Connor" },
    { title: "How to Carry What Can't Be Fixed: A Journal for Grief", author: "Megan Devine" },
    { title: "The Invisible String", author: "Patrice Karst", note: "Picture Book (For Children/Teens)" },
    { title: "No Death, No Fear: Comforting Wisdom for Life", author: "Thich Nhat Hanh", note: "Zen Buddhist Perspective" },
    { title: "No Happy Endings: A Memoir", author: "Nora McInerny" },
    { title: "It's OK That You're Not OK: Meeting Grief and Loss in a Culture That Doesn't Understand", author: "Megan Devine" },
    { title: "Through the Valley of Grief: A 365-Day Devotional of Spiritual Practices for Hope in Suffering", author: "Mattie Jackson", note: "Christian Perspective" },
    { title: "The Wild Edge of Sorrow: Rituals of Renewal and the Sacred Work of Grief", author: "Francis Weller" }
  ];

  const traumaBooks = [
    { title: "The Body Keeps the Score: Brain, Mind, and Body in the Healing of Trauma", author: "Bessel van der Kolk" },
    { title: "Healing Trauma", author: "Peter Levine" },
    { title: "In the Realm of Hungry Ghosts: Close Encounters with Addiction", author: "Gabor Maté & Peter Levine" },
    { title: "It Didn't Start With You", author: "Mark Wolynn" },
    { title: "The Myth of Normal: Trauma, Illness, and Healing in a Toxic Culture", author: "Gabor Maté MD and Daniel Maté" },
    { title: "No Bad Parts", author: "Richard Schwartz" },
    { title: "Scattered Minds: The Origins and Healing of Attention Deficit Disorder", author: "Gabor Maté" },
    { title: "Waking the Tiger", author: "Peter Levine" },
    { title: "When Religion Hurts You: Healing from Religious Trauma and the Impact of High-Control Religion", author: "Laura E. Anderson" }
  ];

  const personalGrowthBooks = [
    { title: "Adult Children of Emotionally Immature Parents: How to Heal from Distant, Rejecting, or Self-Involved Parents", author: "Lindsay C. Gibson" },
    { title: "Attached", author: "Amir Levine & Rachel Heller" },
    { title: "The Book of Joy", author: "Dalai Lama, Desmond Tutu with Douglas Abrams" },
    { title: "The Enneagram: A Christian Perspective", author: "Richard Rohr & Andreas Ebert" },
    { title: "The Highly Sensitive Person", author: "Elaine Aron" },
    { title: "Hold Me Tight", author: " Sue Johnson" },
    { title: "Man's Search for Meaning", author: "Viktor E. Frankl" },
    { title: "On Becoming a Person", author: "Carl Rogers" },
    { title: "Peace Is Every Step: The Path of Mindfulness in Everyday Life", author: "Thich Nhat Hanh", note: "Zen Buddhism Perspective" },
    { title: "Quiet", author: "Susan Cain" },
    { title: "Recovering from Emotionally Immature Parents: Practical Tools to Establish Boundaries and Reclaim Your Emotional Autonomy", author: "Lindsay C. Gibson" },
    { title: "Untie the Strong Woman", author: "Clarissa Pinkola Estés" },
    { title: "Wherever You Go There You Are: Mindfulness Meditation in Everyday Life", author: "Jon Kabat-Zinn" },
    { title: "The Wisdom of the Enneagram: The Complete Guide to Psychological and Spiritual Growth for the Nine Personality", author: "Don Richard Riso & Russ Hudson" },
    { title: "The Wisdom of Your Body", author: "Hillary McBride" },
    { title: "Women Who Run with the Wolves: Myths and Stories of the Wild Woman Archetype", author: "Clarissa Pinkola Estés" }
  ];

  const renderBookList = (books, category) => (
    <div className="book-category">
      <h3>{category}</h3>
      <div className="books-grid">
        {books.map((book, index) => (
          <div key={index} className="book-item">
            <h4 className="book-title">{book.title}</h4>
            <p className="book-author">by {book.author}</p>
            {book.note && <p className="book-note">{book.note}</p>}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="resources">
      <div className="container">
        {/* Header */}
        <div className="resources-header">
          <h1>Mental Health Resources</h1>
          <p>Helpful tools, information, and resources to support your mental wellness journey</p>
        </div>

        {/* Crisis Resources */}
        <section className="crisis-section">
          <h2>🆘 Crisis Resources</h2>
          <div className="crisis-disclaimer">
            <p><strong>Important:</strong> I am not a crisis counselor. Should an emergency occur please contact 911 or 988.</p>
          </div>
          <div className="crisis-grid">
            <div className="crisis-card emergency">
              <h3>National Suicide Prevention Lifeline</h3>
              <p className="phone">988</p>
              <p>Available 24/7 for free and confidential support</p>
              <a href="tel:988" className="crisis-button">Call Now</a>
            </div>
          </div>
        </section>

        {/* Self-Help Tools */}
        <section className="tools-section">
          <h2>🛠️ Self-Help Tools</h2>
          <div className="tools-grid">
            <div className="tool-card">
              <h3>Breathing Exercises</h3>
              <p>Simple techniques to help manage anxiety and stress</p>
              <div className="tool-content">
                <h4>4-7-8 Breathing Technique:</h4>
                <ol>
                  <li>Inhale for 4 seconds</li>
                  <li>Hold for 7 seconds</li>
                  <li>Exhale for 8 seconds</li>
                  <li>Repeat 4 times</li>
                </ol>
              </div>
            </div>
            <div className="tool-card">
              <h3>Grounding Techniques</h3>
              <p>Methods to help you stay present and connected</p>
              <div className="tool-content">
                <h4>5-4-3-2-1 Exercise:</h4>
                <ol>
                  <li>Name 5 things you can see</li>
                  <li>Name 4 things you can touch</li>
                  <li>Name 3 things you can hear</li>
                  <li>Name 2 things you can smell</li>
                  <li>Name 1 thing you can taste</li>
                </ol>
              </div>
            </div>
            <div className="tool-card">
              <h3>Mindfulness Practices</h3>
              <p>Simple mindfulness exercises for daily practice</p>
              <div className="tool-content">
                <h4>Body Scan Meditation:</h4>
                <p>Take 5-10 minutes to slowly scan your body from head to toe, noticing any sensations without judgment.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Recommended Reading */}
        <section className="reading-section">
          <h2>📖 Recommended Reading</h2>
          <p>
            These books have been carefully selected to support various aspects of healing and growth. 
            Each offers unique perspectives and practical tools for your journey.
          </p>
          
          {renderBookList(griefBooks, "Grief")}
          {renderBookList(traumaBooks, "Trauma")}
          {renderBookList(personalGrowthBooks, "Personal Growth")}
        </section>

        {/* Disclaimer */}
        <div className="disclaimer">
          <p><strong>Disclaimer:</strong> These resources are provided for informational purposes only and are not a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition.</p>
        </div>
      </div>
    </div>
  );
};

export default Resources;
